<template>
  <div>
    <div class="globe">
      <span v-if="radio1 !== 'main'">{{ radio1 }}</span>
      <i class="fa fa-globe" aria-hidden="true" @click="dialogVisible = true"></i>
    </div>
    <el-dialog
      append-to-body
      title="Выберите подключение"
      :visible.sync="dialogVisible"
      width="300px"
    >
      <div class="chnage-location">
        <el-radio v-model="radio1" @change="change" label="main" border>Основной сервер</el-radio>
      </div>
      <div class="chnage-location" style="margin-top: 10px">
        <el-radio v-model="radio1" @change="change" label="lk" border>LK сервер</el-radio>

      </div>
      <div class="chnage-location" style="margin-top: 10px">
        <el-radio v-model="radio1" @change="change" label="rk" border>RK сервер</el-radio>

      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ChangeLocation",
  data() {
    return {
      dialogVisible: false,
      radio1: localStorage.getItem('server') || 'main'
    }
  },
  methods: {
    change() {
      const currentServer = localStorage.getItem('server')

      if(this.radio1 !== currentServer) {
        localStorage.setItem('server' ,this.radio1)
        if(this.radio1 === 'lk') {
          window.location.href = '/lk/index.html'
        } else if(this.radio1 === 'rk') {
          window.location.href = '/local/index.html'
        } else {
          window.location.href = '/'
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
i {
  font-size: 20px;
}
</style>
<style lang="scss">
.chnage-location {
  .el-radio {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChangeLocation.vue